import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=1a29ce36"
import script from "./TicketsTable.vue?vue&type=script&lang=js"
export * from "./TicketsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports